<template src="./pendingConciliations.pug" lang="pug"></template>

<script>
import TreeGrid from '../../treeGrid/TreeGrid'
import { EXPORT_TREEGRID } from '../../../../build/jsonToExcel/exportRoutes.js'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../utils/grid-load-transition.js'
import { trackAnalyticsEvent } from '../../../utils/analytics.js'

export default {
  name: 'PendingConciliations',

  components: {
    TreeGrid
  },

  props: {
    resultMov: {
      type: Object,
      required: true
    },
    resultExt: {
      type: Object,
      required: true
    },
    treeGridCfgMov: {
      type: Object,
      required: false
    },
    treeGridCfgExt: {
      type: Object,
      required: false
    },
    showTreegridMov: {
      type: Boolean,
      required: false
    },
    showTreegridExt: {
      type: Boolean,
      required: false
    }
  },

  data () {
    return {
      exportUrl: EXPORT_TREEGRID,
      showHideButtonAddAllMovFin: false,
      showHideButtonAddAllBankStat: false
    }
  },

  methods: {
    startTreeGridLoading (idGrid, messages) {
      startTreeGridLoading(idGrid, messages)
    },

    stopTreeGridLoading (idGrid) {
      stopTreeGridLoading(idGrid)
    },

    // Adiciona todos os lançamentos de movimento financeiro selecionados na grid
    addAllRowsFinMov () {
      setTimeout(() => {
        if (window.Grids.ConcManualMovFin && window.Grids.ConcManualMovFin.GetSelRows().length > 0) {
          window.Grids.ConcManualMovFin.GetSelRows().forEach(row => {
            if (row.Visible) {
              row.isTreeGrid = true
              this.$store.dispatch('setFinMov', row)
                .then(() => {
                  window.Grids.ConcManualMovFin.HideRow(row)
                  this.showHideButtonAddAllMovFin = false
                }).catch((error) => {
                  this.$root.$refs.notification.error(this.$t(error.message))
                })
            } else {
              window.Grids.ConcManualMovFin.SelectRow(row)
            }
          })
        } else {
          this.$root.$refs.notification.warning(this.$t('conciliacaoManual.validacao.selecionarItensMovFin'))
        }
        this.$store.dispatch('dataLoaded')
      }, 100)
      setTimeout(() => {
        window.Grids.ConcManualMovFin.RenderBody()
      }, 150)
    },

    // Adiciona todos os lançamentos de extrato bancário selecionados na grid
    addAllRowsBankStat () {
      setTimeout(() => {
        if (window.Grids.ConcManualExtBan && window.Grids.ConcManualExtBan.GetSelRows().length > 0) {
          window.Grids.ConcManualExtBan.GetSelRows().forEach(row => {
            if (row.Visible) {
              row.isTreeGrid = true
              this.$store.dispatch('setBankStat', row)
                .then(() => {
                  window.Grids.ConcManualExtBan.HideRow(row)
                  this.showHideButtonAddAllBankStat = false
                }).catch((error) => {
                  this.$root.$refs.notification.error(this.$t(error.message))
                })
            } else {
              window.Grids.ConcManualMovFin.SelectRow(row)
            }
          })
        } else {
          this.$root.$refs.notification.warning(this.$t('conciliacaoManual.validacao.selecionarItensBankStat'))
        }
        this.$store.dispatch('dataLoaded')
      }, 100)
      setTimeout(() => {
        window.Grids.ConcManualExtBan.RenderBody()
      }, 150)
    },

    startLoading () {
      this.$store.dispatch('loadingDataStatic')
    }
  },

  mounted () {
    // Escuta o evento emitido quando se seleciona uma ou todas as linhas da grid de Movimento Financeiro
    $(document).on('showHideButtonAddAllMovFin', (data, flag) => {
      this.showHideButtonAddAllMovFin = flag
    })

    // Escuta o evento emitido quando se seleciona uma ou todas as linhas da grid de Extrato Bancário
    $(document).on('showHideButtonAddAllBankStat', (data, flag) => {
      this.showHideButtonAddAllBankStat = flag
    })
  },

  beforeUpdate () {
    if (document.querySelector("[aria-controls='#tab-conciliacoes-pendentes']")) {
      document.querySelector("[aria-controls='#tab-conciliacoes-pendentes']")
        .addEventListener('click', () => {
          trackAnalyticsEvent(this, 'conciliacao-manual', 'click-mudar-de-aba', 'tab-conciliacoes-pendentes')
        })
    }
  }
}
</script>

<style>
.button-addAll {
  background-color: #40b9bb;
  border: 1px solid #40b9bb;
  color: #FFF;
  font-family: 'Inter', sans-serif;
  min-width: 40px;
  text-align: center;
}

.button-addAll:hover {
  background-color: #379d9e;
  border: 1px solid #379d9e;
  color: #FFF;
}

.icon-button-addAll-right {
  margin: 2px 5px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// PendingConciliations.vue?20142633